import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import SideBasket from '../../components/SideBasket/SideBasket';
import {startEditingBasketItem, loadExistingBasketItem} from '../../actions/basketItem.action';
import {
  addVoucher,
  deleteBasket,
  removeBasketItem,
  setPaymentMethod,
  updateFulfillment,
  updateBasketItemQuantity,
  setBasketFulfillAt
} from '../../actions/basket.action';
import {CheckoutPageContentStyled, CheckoutWrapperStyled} from './CheckoutPage.style';
import CheckoutForm from './CheckoutForm';
import {placeBasketOrder} from '../../actions/order.action';
import {
  DINE_COMMENT,
  FINGERPRINT_INIT_TIME_MS,
  FOODIT_LOCALSTORAGE,
  SERVICE_TYPE,
  STATUSES,
  URL_QUERY_PARAMS
} from '../../constants/constant';
import {
  DELIVERY_ADDRESS_NOT_FOUND,
  INVALID_DATE,
  RESTAURANT_CANNOT_ACCEPT_ORDERS
} from '../../constants/errorCodes';
import {SubmissionError} from 'redux-form';
import Fingerprint2 from 'fingerprintjs2';
import {changeFormValue} from '../../actions/form.action';
import CheckoutErrorReportModal from '../../components/CheckoutErrorReportModal/CheckoutErrorReportModal';
import BasketModal from '../../components/Modal/BasketModal';
import InfoModal from '../../components/Modal/InfoModal';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import {boolToServiceType} from '../../helpers/formHelper';
import {calculateFutureOrdersTimeRange, calculateFutureOrdersStartingDate} from '../../helpers/date.helper';
import {
  deletePostcodeFromLocalStorage,
  getVoucherInPromotion,
  getVoucherMessages,
  storeBasketData
} from '../../helpers/checkoutPage.helper';
import {sizes} from '../../styles/components/media-queries';
import {ALLERGY, VOUCHER} from '../../constants/modalType';
import {sendSlackMessage, setBasketConsumer} from '../../actions';
import {showPaymentErrorAlert} from '../../actions/error.action';
import {
  getValueFromLocalStorage,
  persistValueToLocalStorage,
  removeValueFromLocalStorage
} from '../../helpers/localStorage.helper';
import {getSiteUrls, getUrlPath} from '../../helpers/url.helper';

export class CheckoutPage extends PureComponent {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(props.location.search.substring(1));
    const tableId = params.get(URL_QUERY_PARAMS.TABLE_ID);

    this.state = {
      isValidating: false,
      serviceType: null,
      addressLine1: null,
      addressLine2: null,
      email: null,
      phone: null,
      city: null,
      postcode: null,
      modalType: null,
      fulfillmentSubmitted: false,
      isCheckoutTracked: false,
      date: moment(),
      futureTimes: [],
      redirecting: false,
      orderFailed: !!getValueFromLocalStorage(FOODIT_LOCALSTORAGE.ORDER_FAILED),
      showOrderFailedModal: false,
      deviceHash: null,
      tableId: tableId || null,
      navUrls: getSiteUrls(tableId || null)
    };

    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.handleAsyncValidation = this.handleAsyncValidation.bind(this);
    this.handleSetServiceType = this.handleSetServiceType.bind(this);
    this.handleSetPayment = this.handleSetPayment.bind(this);
    this.handleOnDateChange = this.handleOnDateChange.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseErrorModal = this.handleCloseErrorModal.bind(this);
    this.handleErrorReportForm = this.handleErrorReportForm.bind(this);
    this.handleAddVoucher = this.handleAddVoucher.bind(this);
    this.handleOnTimeChange = this.handleOnTimeChange.bind(this);
    this.handleOpenAllergyModal = this.handleOpenAllergyModal.bind(this);
    this.handleOpenVoucherModal = this.handleOpenVoucherModal.bind(this);
    this.handleVoucherChange = this.handleVoucherChange.bind(this);
    this.handleSubmitVoucher = this.handleSubmitVoucher.bind(this);
    this.handleSetServiceTypeCollection = this.handleSetServiceTypeCollection.bind(this);
    this.clearTableId = this.clearTableId.bind(this);
  }

  componentWillMount() {
    const {basket, history} = this.props;
    if (basket.deletedBasket) {
      const url = getUrlPath('/menu', this.state.tableId);
      history.push(url);
    }
  }

  componentDidMount() {
    const {setPaymentErrorFunc, location} = this.props;
    window.scrollTo(0, 0);
    const params = new URLSearchParams(location.search.substring(1));
    const paymentFailed = params.get(URL_QUERY_PARAMS.ERROR) === STATUSES.PAYMENT_FAILED;
    setPaymentErrorFunc(paymentFailed);
    if (window) {
      setTimeout(() => {
        Fingerprint2.get((components) => {
          const values = components.map(component => component.value);
          const deviceHash = Fingerprint2.x64hash128(values.join(''), 31);
          this.setState({deviceHash});
        });
      }, FINGERPRINT_INIT_TIME_MS);
    }
  }

  componentWillReceiveProps() {
    const {basket} = this.props;
    const {isCheckoutTracked} = this.state;

    if (basket.items.length > 0 && !isCheckoutTracked) {
      this.setState({isCheckoutTracked: true});

      let serviceType;
      if (basket.fulfillment) {
        serviceType = boolToServiceType(basket.fulfillment.delivery);
      } else {
        serviceType = SERVICE_TYPE.COLLECTION;
      }

      GoogleAnalyticsHelper.trackConfirmation(basket.items, serviceType);
    }
  }

  changeStartingDate() {
    const {restaurant, form} = this.props;
    const day = calculateFutureOrdersStartingDate(restaurant.openingTimes, form.values.serviceType);

    this.handleOnDateChange(day);
  }

  changeTimeRange(date) {
    const {restaurant, form, changeFormValueFunc} = this.props;
    const futureTimes = calculateFutureOrdersTimeRange(date, restaurant.openingTimes, form.values.serviceType, restaurant.code);

    if (futureTimes[0]) {
      this.setState({futureTimes},
        () => setTimeout(() => this.handleOnTimeChange(futureTimes[0].value), 300)
      );
      changeFormValueFunc('checkoutForm', 'time', futureTimes[0].value);
    }
  }

  setServiceType(initialValidation) {
    const {basket, form, restaurant, changeFormValueFunc, updateFulfillmentFunc} = this.props;
    const {isValidating} = this.state;

    if (isValidating && initialValidation === true || initialValidation !== true && form.values.serviceType === boolToServiceType(basket.fulfillment.delivery)) {
      return;
    }

    this.setState({isValidating: true});

    const delivery = {
      serviceType: form.values.serviceType,
      addressLine1: form.values.addressLine1,
      addressLine2: form.values.city,
      city: form.values.city,
      postcode: form.values.postcode
    };

    if (restaurant.modes.futureOrders) { // we set the calendar starting date only for future orders
      this.changeStartingDate(restaurant, form, this.handleOnDateChange);
    }

    changeFormValueFunc('serviceTypeRadioButtons', 'serviceType', form.values.serviceType);

    storeBasketData({
      formValues: form.values,
      serviceTypeValue: form.values.serviceType
    });

    return updateFulfillmentFunc(basket.uuid, delivery)
      .then(() => this.setState({isValidating: false}))
      .catch(error => {
        this.setState({isValidating: false});

        if (error.response.status === 422 && error.response.data.code === DELIVERY_ADDRESS_NOT_FOUND) {
          deletePostcodeFromLocalStorage();
          return Promise.reject({postcode: 'checkout.deliveryErrorPostcodeNotFound'});
        } else {
          return Promise.reject(error);
        }
      });
  }

  handleSetServiceTypeCollection() {
    const {changeFormValueFunc} = this.props;

    changeFormValueFunc('checkoutForm', 'serviceType', SERVICE_TYPE.COLLECTION);
    this.handleSetServiceType({target: {value: SERVICE_TYPE.COLLECTION}});
  }

  handleOnDateChange(date) {
    this.setState({date});
    this.changeTimeRange(date);
  }

  handleOnTimeChange(value) {
    const {basket, setBasketFulfillAtFunc, restaurant} = this.props;
    let futureOrderTime = null;

    this.setState({isValidating: true});

    if (restaurant.modes.futureOrders && value !== 'ASAP') {
      const hours = value.split(':')[0];
      const minutes = value.split(':')[1];
      futureOrderTime = this.state.date.hours(hours).minutes(minutes);
    }

    setBasketFulfillAtFunc(basket.uuid, futureOrderTime)
      .then(() => this.setState({isValidating: false}))
      .catch(() => this.setState({isValidating: false}));
  }

  handleVoucherChange(event) {
    this.setState({voucherValue: event.target.value});
  }

  handleSubmitVoucher() {
    this.handleAddVoucher(this.state.voucherValue);
  }

  handleOpenVoucherModal(e) {
    e.preventDefault();
    this.setState({modalType: VOUCHER, voucher: null});
  }

  handleOpenAllergyModal(e) {
    e.preventDefault();
    this.setState({modalType: ALLERGY});
  }

  handleCloseModal() {
    this.setState({modalType: null});
  }

  handleErrorReportForm() {
    this.setState({showOrderFailedModal: true});
  }

  handleCloseErrorModal() {
    this.setState({orderFailed: false, showOrderFailedModal: false});
  }

  handleSetServiceType(initialValidation) {
    setTimeout(() => this.setServiceType(initialValidation), 300);
  }

  handleSetPayment(paymentTypeValue) {
    const {basket, form, setPaymentMethodFunc} = this.props;

    storeBasketData({
      formValues: form.values,
      paymentTypeValue: paymentTypeValue.target.value
    });

    this.setState({isValidating: true});

    setPaymentMethodFunc(basket.uuid, paymentTypeValue.target.value)
      .then(() => this.setState({isValidating: false}))
      .catch(() => this.setState({isValidating: false}));
  }

  handleAddVoucher(voucher) {
    const {basket, addVoucherFunc} = this.props;

    this.setState({isValidating: true});

    addVoucherFunc(basket.uuid, voucher)
      .then(result => {
        const appliedVoucher = getVoucherInPromotion(result.basket.promotions);
        if (appliedVoucher && appliedVoucher.applied) {
          setTimeout(this.handleCloseModal, 3000);
        }
        this.setState({isValidating: false});
      })
      .catch(() => this.setState({isValidating: false}));
  }

  handleAsyncValidation(values, dispatch, props, blurredField) {
    const {updateFulfillmentFunc, setConsumerDataFunc, basket, form} = this.props;
    storeBasketData({formValues: values});
    if ( // Validating fullfilment on every blur
      !this.state.isValidating &&
      values.serviceType === SERVICE_TYPE.DELIVERY &&
      values.addressLine1 &&
      values.postcode &&
      values.city &&
      (
        values.addressLine1 !== this.state.addressLine1 ||
        values.addressLine2 !== this.state.addressLine2 ||
        values.city !== this.state.city ||
        blurredField === 'postcode'
      )
    ) {
      this.setState({
        isValidating: true,
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        postcode: values.postcode,
        city: values.city
      });

      return updateFulfillmentFunc(basket.uuid, values)
        .then(() => {
          this.setState({
            isValidating: false,
            fulfillmentSubmitted: true
          });
          return Promise.resolve({});
        })
        .catch(error => {
          this.setState({isValidating: false});
          if (error.response.status === 422 && error.response.data.code === DELIVERY_ADDRESS_NOT_FOUND) {
            deletePostcodeFromLocalStorage();
            return Promise.reject({postcode: 'checkout.deliveryErrorPostcodeNotFound'});
          } else {
            return Promise.reject(error);
          }
        });
    } else if (values.serviceType === SERVICE_TYPE.COLLECTION && this.state.fulfillmentSubmitted === false) {
      // Validating fulfillment on submit
      return updateFulfillmentFunc(basket.uuid, values)
        .then(() => {
          this.setState({
            isValidating: false,
            fulfillmentSubmitted: true
          });
          return Promise.resolve({});
        })
        .catch(error => Promise.reject(error));
    } else if (
      !this.state.isValidating &&
      (form.syncErrors && !form.syncErrors.phone && !form.syncErrors.email) &&
      values.email &&
      values.phone &&
      (values.email !== this.state.email || values.phone !== this.state.phone)
    ) {
      this.setState({
        isValidating: true,
        email: values.email,
        phone: values.phone
      });

      return setConsumerDataFunc(basket.uuid, {email: values.email, phone: values.phone})
        .then(() => {
          this.setState({isValidating: false});
          return Promise.resolve({});
        })
        .catch(error => {
          this.setState({isValidating: false});
          return Promise.reject(error);
        });

    } else {
      return Promise.resolve({});
    }
  }

  clearTableId() {
    const {location, history} = this.props;
    const params = new URLSearchParams(location.search.substring(1));
    params.delete(URL_QUERY_PARAMS.TABLE_ID);
    history.push({
      pathname: location.path,
      search: params.toString()
    });
    window.location.reload();
  }

  handleSubmitForm(values) {
    const {basket, restaurant, form, history, deleteBasketFunc, placeBasketOrderFunc} = this.props;
    const {date, deviceHash, tableId} = this.state;
    const redirectUrl = `${window.location.href.split('/order/')[0]}/order/{orderId}/confirmation?status=submitted`;
    let futureOrderTime;

    if (basket.messages && basket.messages.length > 0) {
      return;
    }

    if (restaurant.modes.futureOrders && values.time !== 'ASAP') {
      const hours = values.time.split(':')[0];
      const minutes = values.time.split(':')[1];
      futureOrderTime = date.hours(hours).minutes(minutes);
    }
    let dineInMsg;
    if (tableId) {
      dineInMsg = `${DINE_COMMENT} ${tableId} `;
    }
    GoogleAnalyticsHelper.trackPayment(basket.items, form.values.paymentType);
    return placeBasketOrderFunc(basket.uuid, values, redirectUrl, window.location.href, futureOrderTime, deviceHash, dineInMsg)
      .then(({order}) => {
        removeValueFromLocalStorage(FOODIT_LOCALSTORAGE.ORDER_FAILED);
        this.setState({redirecting: true});
        if (!order.messages || (order.messages && order.messages.length === 0)) {
          if (order.result === 'ORDERED') {
            deleteBasketFunc();
            history.push(`/order/${order.orderId}/confirmation?status=submitted`);
            return Promise.resolve({});
          } else if (order.result === 'REDIRECT') {
            window.location.href = order.redirectUrl;
            return Promise.resolve({});
          }
        } else {
          return Promise.resolve({});
        }
      })
      .catch(error => {
        persistValueToLocalStorage(FOODIT_LOCALSTORAGE.ORDER_FAILED, true);
        this.setState({redirecting: false});
        if (error.response.status === 422 && error.response.data.code === INVALID_DATE) {
          throw new SubmissionError({
            date: 'checkout.invalidDateError',
            time: 'checkout.invalidDateError',
            _error: 'checkout.invalidDateError'
          });
        } else if (error.response.status === 422 && error.response.data.code === RESTAURANT_CANNOT_ACCEPT_ORDERS) {
          this.setState({modalType: RESTAURANT_CANNOT_ACCEPT_ORDERS});
          throw new SubmissionError();
        } else {
          return Promise.reject(error);
        }
      });
  }

  render() {
    const {
      basket,
      restaurant,
      menu,
      isSideBasketLoading,
      loadExistingBasketItemFunc,
      removeBasketItemFunc,
      updateBasketItemQuantityFunc,
      form,
      template,
      resizeProps, // see ResizeHandler.js
      sendSlackMessageFunc
    } = this.props;

    const {
      modalType,
      isValidating,
      date,
      futureTimes,
      voucherValue,
      redirecting,
      orderFailed,
      navUrls,
      tableId
    } = this.state;

    const isMobile = resizeProps.windowWidth < sizes.small[resizeProps.orientation];
    const editingMeals = {};

    if (menu && menu.meals) {
      basket.items.forEach(item => (editingMeals[item.mealUuid] = menu.meals[item.mealUuid]));
    }

    const renderInfoModal = modalType === RESTAURANT_CANNOT_ACCEPT_ORDERS &&
      InfoModal({
        type: modalType,
        closeModalCallback: this.handleCloseModal
      });

    const renderErrorCheckoutReportModal = this.state.showOrderFailedModal &&
      (
        <CheckoutErrorReportModal
          handleCloseModal={this.handleCloseErrorModal}
          phone={restaurant.contactNumber}
          isMobile={isMobile}
          restaurant={restaurant}
          sendSlackMessage={sendSlackMessageFunc}
        />
      );

    const voucherMessages = form && basket.promotions && getVoucherMessages(basket.promotions, form.values.serviceType);
    const isTemplateLight = template && template.name === 'light';

    return (
      <CheckoutWrapperStyled>
        <CheckoutPageContentStyled
          data-rw="checkout-page--content"
          isTemplateLight={isTemplateLight}
        >
          {
            basket.uuid && (
            <CheckoutForm
              asyncValidate={this.handleAsyncValidation}
              basket={basket}
              closeModal={this.handleCloseModal}
              date={date}
              checkoutForm={form}
              futureTimes={futureTimes}
              isValidating={isValidating}
              onDateChange={this.handleOnDateChange}
              onSubmit={this.handleSubmitForm}
              onTimeChange={this.handleOnTimeChange}
              openAllergyModal={this.handleOpenAllergyModal}
              openVoucherModal={this.handleOpenVoucherModal}
              restaurant={restaurant}
              setPayment={this.handleSetPayment}
              setServiceType={this.handleSetServiceType}
              setServiceTypeCollection={this.handleSetServiceTypeCollection}
              modalType={modalType}
              submitVoucher={this.handleSubmitVoucher}
              voucherChange={this.handleVoucherChange}
              voucherMessages={voucherMessages}
              voucherValue={voucherValue}
              redirecting={redirecting}
              isTemplateLight={isTemplateLight}
              orderFailed={orderFailed}
              handleErrorReportForm={this.handleErrorReportForm}
              tableId={tableId}
              clearTableId={this.clearTableId}
              navUrls={navUrls}
            />
          )}
        </CheckoutPageContentStyled>
        <SideBasket
          isMenuPage={false}
          showPaymentIcons={false}
          showServiceTypeRadioButtons={false}
          isLoading={isSideBasketLoading}
          basketItems={basket.items}
          basketUuid={basket.uuid}
          price={basket.price}
          promotions={basket.promotions}
          editingMeals={editingMeals}
          loadExistingBasketItem={loadExistingBasketItemFunc}
          removeBasketItem={removeBasketItemFunc}
          updateBasketItemQuantity={updateBasketItemQuantityFunc}
          payment={restaurant.payment}
          restaurantModes={restaurant.modes}
          promotionMessages={restaurant.content.promotions}
          isSticky={!isMobile}
          isTemplateLight={isTemplateLight}
          exceptionalClosingTimes={restaurant.exceptionalClosingTimes}
        />
        <BasketModal restaurantModes={restaurant.modes} />
        {renderInfoModal}
        {renderErrorCheckoutReportModal}
      </CheckoutWrapperStyled>
    );
  }
}

CheckoutPage.propTypes = {
  addVoucherFunc: PropTypes.func.isRequired,
  basket: PropTypes.object.isRequired,
  changeFormValueFunc: PropTypes.func.isRequired,
  deleteBasketFunc: PropTypes.func.isRequired,
  form: PropTypes.object,
  history: PropTypes.object.isRequired,
  isSideBasketLoading: PropTypes.bool.isRequired,
  loadExistingBasketItemFunc: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  placeBasketOrderFunc: PropTypes.func.isRequired,
  removeBasketItemFunc: PropTypes.func.isRequired,
  restaurant: PropTypes.object.isRequired,
  setPaymentMethodFunc: PropTypes.func.isRequired,
  setBasketFulfillAtFunc: PropTypes.func.isRequired,
  updateBasketItemQuantityFunc: PropTypes.func.isRequired,
  updateFulfillmentFunc: PropTypes.func.isRequired,
  setConsumerDataFunc: PropTypes.func.isRequired,
  resizeProps: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  setPaymentErrorFunc: PropTypes.func.isRequired,
  template: PropTypes.object.isRequired,
  sendSlackMessageFunc: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language,
    basket: state.basket,
    isSideBasketLoading: state.loading.sideBasket,
    form: state.form.checkoutForm,
    template: state.template
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addVoucherFunc: bindActionCreators(addVoucher, dispatch),
    changeFormValueFunc: bindActionCreators(changeFormValue, dispatch),
    deleteBasketFunc: bindActionCreators(deleteBasket, dispatch),
    loadExistingBasketItemFunc: bindActionCreators(loadExistingBasketItem, dispatch),
    placeBasketOrderFunc: bindActionCreators(placeBasketOrder, dispatch),
    removeBasketItemFunc: bindActionCreators(removeBasketItem, dispatch),
    setBasketFulfillAtFunc: bindActionCreators(setBasketFulfillAt, dispatch),
    setPaymentMethodFunc: bindActionCreators(setPaymentMethod, dispatch),
    startEditingBasketItem: bindActionCreators(startEditingBasketItem, dispatch),
    updateBasketItemQuantityFunc: bindActionCreators(updateBasketItemQuantity, dispatch),
    updateFulfillmentFunc: bindActionCreators(updateFulfillment, dispatch),
    setConsumerDataFunc: bindActionCreators(setBasketConsumer, dispatch),
    sendSlackMessageFunc: bindActionCreators(sendSlackMessage, dispatch),
    setPaymentErrorFunc: bindActionCreators(showPaymentErrorAlert, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextProvider(CheckoutPage));



// WEBPACK FOOTER //
// ./containers/CheckoutPage/CheckoutPage.js